{{#if selected}}
    {{#if showWithCancelIcon}}
        <span data-value="{{id}}" {{#unless id}} class="not-selected" {{/unless}}>{{#if hasSelectionName}}{{selectionName}}{{else}}{{name}}{{/if}}{{#if id}} {{icon name="circle-close-solid" className="flex-dropdown-remove-item" locale="clear"}}{{/if}}</span>
    {{else}}
        <span>{{#if hasSelectionName}}{{selectionName}}{{else}}{{name}}{{/if}}</span>
    {{/if}}
{{/if}}